import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import BusinessSolutionBody from "./Components/BodyBusinessSolution";


class UKBusinessSolution extends React.Component {
    render() {
        return (<>
            <Nav />
            <BusinessSolutionBody/>
            <Footer />
        </>
        );

    }
}

export default UKBusinessSolution;